import { render } from "./GasTopHolder.vue?vue&type=template&id=da82977c"
import script from "./GasTopHolder.vue?vue&type=script&lang=js"
export * from "./GasTopHolder.vue?vue&type=script&lang=js"

import "./GasTopHolder.vue?vue&type=style&index=0&id=da82977c&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__